import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import menu from "../../../../models/menu.model";
import { loadAL } from "../../../../services/menu.service";
import {Link} from 'react-router-dom';
// import translates from '../../../../translation.json';
import { lang } from "../../../../config/app.config";
import {TranslationState} from '../../../../store/ActionReducers/translation.actionreducer';
interface state{
  menu:{
    additionalLinks:menu,
    loadingAL:boolean
  },
  translation:TranslationState
}


const FooterAl:React.FC = () =>{
  // redux states
  const state = useSelector((state:state)=>{
    return state;
  });


  const {menu,translation:trans} = state;
  const {additionalLinks,loadingAL} = menu;

  const dispatch = useDispatch();
  
  useEffect(()=>{
    if(!additionalLinks) dispatch(loadAL('additional-links'))
  },[dispatch]); //eslint-disable-line


  return(
    <>
    {loadingAL?"":
    <>
      <h3 className="text-16-white">{trans.translation?trans.translation.quick_links[lang==='np'?'value_np':'value_en']:''}</h3>
      <ul>
      {    
            additionalLinks && additionalLinks.children.length?
            additionalLinks.children.map(item=>{
              let isLinkToExternal=item?.key?.startsWith('https');
              let finalLink= isLinkToExternal ? {pathname:item?.key} :`/${lang}${item.key}`;
              return (
              <li key={item.id} >
                <Link to={finalLink} target={isLinkToExternal ? '_blank':'_self'}>{item.name}</Link>
              </li>
            )}
            ):''
          }
      </ul>
      </>
    }
    </>
  );
}

export default FooterAl;